module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-fun-smile-section"
  }, [_c('div', {
    staticClass: "custom-fun-smile-section__container"
  }, [_c('Intro', {
    attrs: {
      "props": _vm.props.intro
    }
  }), _c('div', {
    staticClass: "custom-fun-smile-section__row-top"
  }, _vm._l((_vm.props.row_top), function(content, i) {
    return _c('div', {
      key: i,
      staticClass: "custom-fun-smile-section__col"
    }, [_c('h3', [_vm._v(_vm._s(content.title))]), _c('div', {
      staticClass: "custom-fun-smile-section__text",
      domProps: {
        "innerHTML": _vm._s(content.content)
      }
    })])
  })), _c('div', {
    staticClass: "custom-fun-smile-section__row-bottom"
  }, [_c('div', {
    staticClass: "custom-fun-smile-section__img"
  }, [_c('img', {
    attrs: {
      "src": _vm.props.row_bottom.img
    }
  })]), _c('div', {
    staticClass: "custom-fun-smile-section__bottom-text",
    domProps: {
      "innerHTML": _vm._s(_vm.props.row_bottom.text)
    }
  })])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ee88de28","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-fun-smile-section/custom-fun-smile-section.pug
// module id = 1143
// module chunks = 1